/**
 * The client's copy of `StudioLimits` (springboot-shared-library
 * `src/main/kotlin/com/xconvert/springbootsharedlibrary/compose/StudioLimits.kt:13-23`).
 *
 * ADVISORY, NOT AUTHORITATIVE. Both server tiers read these from `settings.studio` and
 * refuse on them -- professorx above `ScheduleAdmission`, ironman above `checkAndRegister`
 * -- and `settings.studio` is NOT part of the `/v1/api/settings` response the browser gets
 * (checked 2026-09-12: `utils/request.utils.ts` mirrors `featureFlags` and `UserSettings`
 * and has no `studio` block). So the browser cannot know a lowered limit, and these numbers
 * exist to keep the UI from letting a user build something that will be refused -- a
 * disabled "Add photo" button at 30 clips, not a second enforcement point. This is the
 * controller's ruling 2 on the open questions ("Not in v1. The client's limits are a UI
 * clamp mirrored from `StudioLimits.kt` by a spec; the server refuses authoritatively").
 *
 * The consequence, stated so nobody is surprised by it: if an operator lowers
 * `studio.maxClips` on the fleet, the editor still lets the user reach the old limit and
 * the refusal arrives at export as a 400 the export sheet renders (P5a.3). That is the
 * correct failure -- the server is the authority -- and it is why P5a.3's refusal rendering
 * is not optional.
 *
 * `limits.spec.ts` reads StudioLimits.kt and fails if any number here parts company with it.
 */
export interface StudioLimits {
    maxClips: number;
    maxHoldMs: number;
    maxTotalMs: number;
    maxOutputMegapixelFrames: number;
    maxMusicMs: number;
}

export const STUDIO_LIMITS: Readonly<StudioLimits> = Object.freeze({
    maxClips: 30,
    maxHoldMs: 60_000,
    maxTotalMs: 1_200_000,
    maxOutputMegapixelFrames: 80_000,
    maxMusicMs: 240_000,
});
